import { CONFIG_API, DATA_API } from "@/plugins/axios";
import { store } from "@/store/store";
import router from "@/router";

export default class User {
    id = "";
    username = "";
    first_name = "";
    last_name = "";
    email = "";
    password = "";
    is_staff = false;
    is_superuser = false;
    is_active = false;
    is_investor = false;
    date_joined = "";
    last_login = "";

    constructor(user) {
        if (user) {
            Object.assign(this, user);
        }
    }
    getId() {
        return this.id;
    }
    getUsername() {
        return this.username;
    }
    getEmail() {
        return this.email;
    }
    getInitials() {
        if (this.first_name || this.last_name) {
            return this.first_name.charAt(0) + this.last_name.charAt(0);
        }
        return this.username.charAt(0);
    }

    getFullname() {
        if (this.first_name || this.last_name) {
            return `${this.first_name} ${this.last_name}`;
        }
        return this.username;
    }
}
function parseClass(data) {
    let users = [];
    data.forEach(element => {
        let user = new User(element);
        users.push(user);
    });
    return users;
}

export async function getUser(data) {
    let res = undefined;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            },
            params: data
        };
        res = await CONFIG_API.get(`/users/${data.id}/`, config);
    } catch (e) {
        console.warn(e);
    }
    if (res && res.status == 200) return new User(res.data);
    return null;
}

export async function getUsers(params) {
    let res;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            },
            params
        };
        res = await CONFIG_API.get("/users/", config);
    } catch (error) {
        console.error(error);
    }
    if (params && params.page) {
        if (res && res.status == 200) {
            res.data.results = parseClass(res.data.results);
            return res.data;
        }
        return {
            links: {
                next: null,
                previous: null
            },
            total: 0,
            page: 0,
            page_size: 0,
            results: []
        };
    } else {
        if (res && res.status == 200) return parseClass(res.data);
        return [];
    }
}

export async function insertUser(data) {
    let res;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            }
        };
        res = await CONFIG_API.post("/users/", data, config);
        return res;
    } catch (error) {
        console.error(error);
    }
}

export async function updateUser(data) {
    let res = undefined;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            }
        };
        res = await CONFIG_API.put(`/update_user/${data.id}/`, data, config);
        return res.status;
    } catch (error) {
        console.warn(error);
    }
    if (res && res.status == 200) return res.data;
    return null;
}

export async function changePassword(id, newPassword) {
    let res = undefined;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: "JWT " + localStorage.getItem("config_token")
            }
        };
        let params = {
            new_password: newPassword
        };
        res = await CONFIG_API.put(`/change_password/${id}/`, params, config);
        return res.status;
    } catch (error) {
        console.warn(error);
    }
    if (res && res.status == 200) return res.data;
    return null;
}

export async function removeUser(id) {
    if (id) {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    Authorization: "JWT " + localStorage.getItem("config_token")
                }
            };
            CONFIG_API.delete(`/users/${id}/`, config);
        } catch (error) {
            console.error(error);
        }
    }
}

export async function login(data) {
    try {
        const res = await CONFIG_API.post("/users/login/", data);
        localStorage.setItem("config_token", res.data.token);
        store.commit("setToken", res.data.token);
        return res;
    } catch (error) {
        return Promise.reject(error);
    }
}

export async function loginDataAPI(data) {
    try {
        const res = await DATA_API.post("/users/login/", data);
        localStorage.setItem("data_token", res.data.token);
        store.commit("setDataToken", res.data.token);
        return res;
    } catch (error) {
        return Promise.reject(error);
    }
}

export function logout() {
    localStorage.clear();
    router.push({ name: "login" }).catch(()=>{});
    store.commit("logout");
}

export async function checkConfigToken() {
    try {
        const token = localStorage.getItem("config_token");
        if (!token) return false;
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Authorization: "JWT " + token
        };
        let res = await CONFIG_API.get("users/check_token/", { headers });
        if (res.status === 200) {
            return true;
        }
        return false;
    } catch (error) {
        return false;
    }
}

export async function checkDataToken() {
    try {
        const token = localStorage.getItem("data_token");
        if (!token) return false;
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Authorization: "JWT " + token
        };
        let res = await DATA_API.get("users/check_token/", { headers });
        if (res.status === 200) {
            return true;
        }
        return false;
    } catch (error) {
        return false;
    }
}

export async function checkAllTokens() {
    try {
        let res = await Promise.all([checkDataToken(), checkConfigToken()]);
        return res.every(e => e);
    } catch (error) {
        return false;
    }
}

export async function getCurrentUser() {
    try {
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Authorization: "JWT " + localStorage.getItem("config_token")
        };
        const res = await CONFIG_API.get("/users/get_current_user/", { headers });
        const user = new User(res.data);
        localStorage.setItem("currentUser", JSON.stringify(user));
        store.commit("setUser", user);
        return user;
    } catch (error) {
        return Promise.reject(error);
    }
}
